<template>
    <transition name="slide">
        <div v-if="showBanner" :style="{ 'height': bannerHeight + 'px' }">
            <div class="container-fluid">
            </div>
        
            <div class="banner-container container-fluid" v-if="showBanner" ref="banner">
                <div class="row">
                    <div class="col-md-10 col-12">
                        <span v-text="$t('cookiePolicy.message')"></span>
                        <a href="https://www.yubion.com/cookie-policy" target="_blank">
                            <span v-text="$t('cookiePolicy.cookiePolicy')"></span>
                        </a>
                    </div>
                    <div class="col-md-2 col-12">
                        <button class="btn btn-light" @click="okBannerClicked" v-text="$t('cookiePolicy.okButton')"></button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { defineComponent, inject, computed, ref, onMounted, onBeforeUnmount } from 'vue' // eslint-disable-line
import useCookies from '../../composable/useCookies';

export default defineComponent({
	name: 'CookieBanner',
	components:{
		
	},
    setup(props, context) { // eslint-disable-line
		
		//Google Analytics
		const gtag = inject('gtag');
		const { showBanner, okClicked } = useCookies(gtag);
		const okBannerClicked = () => {
            const result = okClicked();
            sizeChanged();
            return result;
        };
        
        const banner = ref(null);
        const bannerHeight = ref(null);
        const sizeChanged = () => {
            Promise.resolve().then(() => {
                bannerHeight.value = banner?.value?.offsetHeight;
            });
        }
        let resizeHandled = false;
        onMounted(() => {
            if(showBanner?.value){
                resizeHandled = true;
                window.addEventListener('resize', sizeChanged);
                sizeChanged();
            }
        });
        onBeforeUnmount(() => {
            if(resizeHandled){
                window.removeEventListener('resize', sizeChanged);
            }
        });
        
		return {
			showBanner,
			okBannerClicked,
            banner,
            bannerHeight,
		};
    },
});

</script>
<style scoped lang="scss">

.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.5s;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}
.banner-container {
    background-color: #222222;
    color: #dddddd;
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 10px;
    padding-right: 10px;
	position: fixed;
	bottom: 0;
    z-index: 1000;
}
.banner-container a {
    text-decoration: none;
}
</style>